export class LegalEntitySimpleListItem {
    id: string;
    name: string;
}